import { t } from 'i18next';


export const demographyAdapter = (data: any, isBio: boolean) => {
	const demography: PatientDemography = {
		// birthYear: data.birthYear,
		birthDate: isBio ? null : data.birthDate || null,
		gender: t(data.gender),
		ecog: data.ecog,
		app: data.app,
		age: data.age || null,
		// consent: data.file, 
		createdAt: data.createdAt,
	};

	return demography;
};

export const sampleAdapter = (data: any) => {
	const sample: PatientSample = {
		sampleType: data.sampleType,
		sampleDate: data.sampleDate,
	};

	return sample;
};

export const diagnosticAdapter = (data: any, isBio: boolean) => {
	const diagnostic: PatientDiagnostic = {
		createdAt: data.createdAt,
		dxDate: data.dxDate,
		dxSecondary: data.dxSecondary,
		dxSubType: data.dxSubType,
		// id: data.id,
		organsFailures: data.organsFailures,
		patientFit: data.patientFit,
		// patientId: data.patientId,
		relapse: data.relapse,
		relapseDate: data.relapseDate,
		riskLevel: data.riskLevel,
		consent: isBio ? 'BioBanco' : data.consent,
		consentDate: data.consentDate,
	};

	return diagnostic;
};

export const treatmentAdapter = (data: any) => {
	const treatment: PatientTreatment = {
		scheme: data.scheme,
		startDate: data.startDate,
		drugs: data.drugs,
		toxicities: data.toxicities,
		diseaseAssessment: data.diseaseAssessment,
		medulogram: data.medulogram,
		medulogramDate: data.medulogramDate,
		EMR: data.EMR,
		EMRDate: data.EMRDate,
		EMRBlasts: data.EMRBlasts,
		clinicalMonitoring: data.clinicalMonitoring,
	};

	return treatment;
};

export const reportsAdapter = (data: any) => {
	let reports = {};
	data.forEach((report: ReportI) => {
		reports = {
			...reports,
			[report.name]: report.content,
		};
	});
	return reports;
};
